import { Routes } from '@angular/router';
import { AuthGuard } from 'src/helpers/auth.guard';
import { GroupInvitationExpiredComponent, UnderConstructionComponent, ValidateInvitationComponent } from './shared/components';

export const routes: Routes = [
  { 
    path: 'account', 
    loadChildren: () => import('./account/account.routes').then(m => m.ACCOUNT_ROUTES) 
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./user/user.routes').then(m => m.USER_ROUTES)
  },
  { path: 'under-construction', component: UnderConstructionComponent},
  { path: 'invitation-expired', component: GroupInvitationExpiredComponent},
  { path: 'validate-invitation', component: ValidateInvitationComponent }
];
